import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaLeaf, FaEnvelope, FaPhone, FaMapMarkerAlt, 
  FaFacebook, FaTwitter, FaLinkedin, FaInstagram,
  FaPaperPlane
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    nombreClub: '',
    mensaje: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí se puede integrar con un servicio de email o backend
    console.log('Formulario enviado:', formData);
    setSubmitted(true);
    
    // Resetear formulario después de 3 segundos
    setTimeout(() => {
      setFormData({
        nombre: '',
        email: '',
        telefono: '',
        nombreClub: '',
        mensaje: ''
      });
      setSubmitted(false);
    }, 3000);
  };

  return (
    <footer className="footer">
      {/* Sección de contacto */}
      <section id="contacto" className="contact-section">
        <div className="container">
          <h2 className="section-title">
            Solicita tu <span className="highlight">Demo Gratuita</span>
          </h2>
          <p className="section-subtitle">
            Déjanos tus datos y nos pondremos en contacto contigo para mostrarte
            todas las funcionalidades de Gestión Club.
          </p>

          <div className="contact-wrapper">
            <div className="contact-form-container">
              {!submitted ? (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="nombre">Nombre completo *</label>
                      <input
                        type="text"
                        id="nombre"
                        name="nombre"
                        value={formData.nombre}
                        onChange={handleChange}
                        required
                        placeholder="Tu nombre"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">Email *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="tu@email.com"
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="telefono">Teléfono</label>
                      <input
                        type="tel"
                        id="telefono"
                        name="telefono"
                        value={formData.telefono}
                        onChange={handleChange}
                        placeholder="+34 600 000 000"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="nombreClub">Nombre del Club</label>
                      <input
                        type="text"
                        id="nombreClub"
                        name="nombreClub"
                        value={formData.nombreClub}
                        onChange={handleChange}
                        placeholder="Nombre de tu asociación"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="mensaje">Mensaje</label>
                    <textarea
                      id="mensaje"
                      name="mensaje"
                      value={formData.mensaje}
                      onChange={handleChange}
                      rows="4"
                      placeholder="Cuéntanos qué necesitas..."
                    ></textarea>
                  </div>

                  <button type="submit" className="btn btn-primary btn-submit">
                    <FaPaperPlane /> Enviar Solicitud
                  </button>
                </form>
              ) : (
                <div className="success-message">
                  <div className="success-icon">✓</div>
                  <h3>¡Solicitud Enviada!</h3>
                  <p>Gracias por tu interés. Nos pondremos en contacto contigo muy pronto.</p>
                </div>
              )}
            </div>

            <div className="contact-info">
              <h3 className="info-title">Información de Contacto</h3>
              
              <div className="info-item">
                <div className="info-icon">
                  <FaEnvelope />
                </div>
                <div className="info-content">
                  <h4>Email</h4>
                  <p>info@gestionclub.com</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <FaPhone />
                </div>
                <div className="info-content">
                  <h4>Teléfono</h4>
                  <p>+34 900 000 000</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <FaMapMarkerAlt />
                </div>
                <div className="info-content">
                  <h4>Ubicación</h4>
                  <p>Barcelona, España</p>
                </div>
              </div>

              <div className="social-links">
                <a href="#" className="social-link" aria-label="Facebook">
                  <FaFacebook />
                </a>
                <a href="#" className="social-link" aria-label="Twitter">
                  <FaTwitter />
                </a>
                <a href="#" className="social-link" aria-label="LinkedIn">
                  <FaLinkedin />
                </a>
                <a href="#" className="social-link" aria-label="Instagram">
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <FaLeaf className="footer-logo-icon" />
              <span>Gestión Club</span>
            </div>
            <p className="footer-text">
              © {new Date().getFullYear()} Gestión Club. Software profesional para clubes cannábicos.
              Todos los derechos reservados.
            </p>
            <div className="footer-links">
              <Link to="/privacidad">Política de Privacidad</Link>
              <span>•</span>
              <Link to="/terminos">Términos de Servicio</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

